import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import allReducers from "./redux/rootReducers";
import App from "./components/App";
import ReduxThunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { ToastProvider } from "react-toast-notifications";
import * as serviceWorker from "./serviceWorker";
import { migrateClinicalHistory } from "./scripts/migrateHistory";

// Expose migration tool
window.migrateClinicalHistory = migrateClinicalHistory;

const store = createStore(
  allReducers,
  composeWithDevTools(applyMiddleware(ReduxThunk))
);

// ReactDOM.render(
//   <Provider store={store}>
//     <ToastProvider autoDismiss>
//       //<FirebaseAppProvider firebaseConfig={firebaseConfig}>
//         <Suspense fallback={"Cargando app"}>
//           <App />
//         </Suspense>
//       </FirebaseAppProvider>
//     </ToastProvider>
// mi primer cambio de ubil
//   </Provider>,

//   document.getElementById("root")
// );

ReactDOM.render(
  <Provider store={store}>
    <ToastProvider autoDismiss>
      <App />
    </ToastProvider>
  </Provider>,

  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();